import { render, staticRenderFns } from "./ButtonBroadcast.vue?vue&type=template&id=6a70c3f7&scoped=true&"
import script from "./ButtonBroadcast.vue?vue&type=script&lang=js&"
export * from "./ButtonBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBroadcast.vue?vue&type=style&index=0&id=6a70c3f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70c3f7",
  null
  
)

export default component.exports